import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerPortalComponent } from './customer-portal.component';
import { BusinessAccountRequestModule } from './../business-account-request';
import { InviteUserModule } from './../invite-users';
import { MatTabsModule } from '@angular/material/tabs';
import { CustomerSupportModule } from '../customer-support/customer-support.module';

@NgModule({
	declarations: [
		CustomerPortalComponent
	],
	imports: [ CommonModule, BusinessAccountRequestModule, InviteUserModule, MatTabsModule, CustomerSupportModule ],
	exports: [
		CustomerPortalComponent
	],
	providers: [

	]
})
export class CustomerPortalModule {}
